import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState, } from "react";
import { loadConfig } from "@cartridge/presets";
const PresetColorContext = createContext(null);
export function ControllerPresetProvider({ children, }) {
    // Cache of configName -> primary color. `null` means the preset was loaded
    // but has no primary color.
    const [colors, setColors] = useState({});
    // Tracks presets whose fetch has already been started so each preset is
    // fetched at most once for the lifetime of the provider.
    const requested = useRef(new Set());
    const ensureLoaded = useCallback((configName) => {
        if (requested.current.has(configName)) {
            return;
        }
        requested.current.add(configName);
        loadConfig(configName)
            .then((config) => {
            const color = config?.theme?.colors?.primary?.toString() ?? null;
            setColors((prev) => ({ ...prev, [configName]: color }));
        })
            .catch(() => {
            setColors((prev) => ({ ...prev, [configName]: null }));
        });
    }, []);
    const getColor = useCallback((configName) => colors[configName] ?? null, [colors]);
    const value = useMemo(() => ({ getColor, ensureLoaded }), [getColor, ensureLoaded]);
    return (_jsx(PresetColorContext.Provider, { value: value, children: children }));
}
export const usePresetColor = (configName) => {
    const ctx = useContext(PresetColorContext);
    useEffect(() => {
        if (configName) {
            ctx?.ensureLoaded(configName);
        }
    }, [configName, ctx]);
    if (!configName || !ctx) {
        return null;
    }
    return ctx.getColor(configName);
};
//# sourceMappingURL=preset-provider.js.map